import { render } from "./Cart_Course_Item.vue?vue&type=template&id=4c205d70&scoped=true"
import script from "./Cart_Course_Item.vue?vue&type=script&lang=js"
export * from "./Cart_Course_Item.vue?vue&type=script&lang=js"

import "./Cart_Course_Item.vue?vue&type=style&index=0&id=4c205d70&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c205d70"]])

export default __exports__